import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_SHOPPING_LIST = `${BASE_URL}/api/shopping-list`;

export class ShoppingListApi {
  static async getShoppingList(weekStartDates = []) {
    const params = new URLSearchParams();
    weekStartDates.forEach((d) => params.append("weekStartDates", d));
    return (await axiosInstance.get(`${BASE_URL_SHOPPING_LIST}`, { params })).data;
  }

  static async addItemsToShoppingList(items, weekStartDate) {
    return (await axiosInstance.post(
      `${BASE_URL_SHOPPING_LIST}/items`,
      items,
      { params: weekStartDate ? { weekStartDate } : {} }
    )).data;
  }

  static async clearShoppingList() {
    return (await axiosInstance.delete(`${BASE_URL_SHOPPING_LIST}`).data);
  }

  static async removeItemsFromShoppingListByIds(id) {
    return (await axiosInstance.delete(
      `${BASE_URL_SHOPPING_LIST}/${id}`
    ));
  }

  static async toggleItemCheck(id) {
    return (await axiosInstance.patch(
      `${BASE_URL_SHOPPING_LIST}/${id}`
    ));
  }


}
